import Vue from 'vue'
import App from './App.vue'
import store from './store'
import utils from './utils/utils.js'
import router from './router'
import './plugins/base'
import common from '@/plugins/common';
import page from '@/plugins/page';
import VueCookies from 'vue-cookies'
import axios from 'axios'
import { vuetify, themesColors } from '@/plugins/vuetify'
import VuetifyDialog from 'vuetify-dialog'
import VueLoadmore, { locale } from 'vuejs-loadmore'
import '@/router/navigationGuard'
import AppBarNew from '@/components/layout/AppBarNew'

Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.use(common);
Vue.use(page);
Vue.use(VueCookies);
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})
Vue.use(VueLoadmore)
locale.use('en-US')
Vue.component('AppBar', AppBarNew)

// 공통 Console log (개발용)
Vue.prototype.$logs = function (...args) {
  console.log(args)
}

// payload 공통
Vue.prototype.$_payload = function (key, params) {
  return {
    key: key,
    params: params
  }
}

Vue.prototype.$fileUrl = function (fileId) {
  return utils.File.getFileUrl(fileId)
}

Vue.prototype.$downUrl = function (fileName) {
  return utils.File.getDownUrl(fileName)
}

const modalOptions = {
  persistent: true,
  showClose: false,
  flat: true
}

// System alert 공통
Vue.prototype.$alert = function (msg, custom = {}) {
  let clone = Object.assign({}, {
      actions: [{
        text: '확인',
        key: true
      }],
    ...modalOptions
  })
  let options = Object.assign(clone, custom)
  return this.$dialog.info({
    text: msg,
    ...options
  })
}

// System confirm 공통
// https://www.npmjs.com/package/vuetify-dialog 참조
// close, dim = undefined
// 오른쪽 = true
// 왼쪽 = false
Vue.prototype.$confirm = function (msg, custom = {}) {
  let clone = Object.assign({}, {
    actions: {
      false: '취소',
      true: '확인'
    },
    ...modalOptions
  })
  let options = Object.assign(clone, custom)
  return this.$dialog.confirm({
    text: msg,
    ...options
  })
}

// global.d3 = require('d3')

global.jQuery = require('jquery');
const $ = global.jQuery;
window.$ = $;

new Vue({
  vuetify,
  router,
  store,
  data: () => ({
    notchTop: 0,
    notchBottom: 0
  }),
  created () {
    this.getNotch()
  },
  mounted() {
    // 애니핏프로 commonJs
    if (!window.commonJs) {
      window.commonJs = {}
    }

    window.commonJs.onBackPressed = function () {
      window.history.back()
    }

  },
  methods: {
    setThemes (clientCd) {
      let themeName = clientCd
      const theme = themesColors.filter(value => value.name === themeName)
      if (theme.length !== 0) {
        const light = theme[0].light
        Object.keys(light).forEach(i => {
          this.$vuetify.theme.themes.light[i] = light[i]
        })
      }
      document.documentElement.dataset.theme = clientCd
    },
    getNotch () {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('android') >= 0) {
        // Empty Block
      } else {
        window.webkit.messageHandlers.getIOSNotch.postMessage('1234')
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
